export const FEEDBACK_EMAIL = 'help@ververica.cloud';
